import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { BasicTable, MASK_MONEY } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { _ScheduleEmployeeBonus } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { EmployeeBonusEditor } from "../../../../ParametrosTalentoHumano/EmployeeBonus/Editors/EmployeeBonus.Editor";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import useModal, { MODAL_LG, MODAL_md } from "../../../../../theme/Component/hooks/useModal";
import { ScheduleEmployeeBonusItem } from "./ScheduleEmployeeBonusItem.tsx/ScheduleEmployeeBonusItem";



export const ScheduleEmployeeBonus = () => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_ScheduleEmployeeBonus);
    const [Account, setAccount] = useState<number>(null)
    const [fecha, setfecha] = useState<any>(_single.getCurrenDate());
    const [EmployeeBonus, setEmployeeBonus] = useState<number>(null);

    const modal = useModal("", MODAL_LG);
    const modalC = useModal("Eliminar beneficio Temporal", MODAL_md);
    const beneficiary = useModal(`Liquidación de beneficiario ${bean.AccountName} `, MODAL_LG);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        instance.getScheduleEmployeeBonusCatalog(Account, EmployeeBonus, fecha).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { toast.error(err) })

    }

    const create = () => {
        setBean({
        });
        modal.open("Agregar Beneficio Temporal")
    }
    const deleteItem = () => {
        instance.deleteScheduleEmployeeBonus(bean.IDScheduleEmployeeBonus, _single.getAccountID()).then(
            (resp: any) => {
                getLista();
                modalC.close();
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const editaItem = () => {
        if (!bean.IDAccount) {
            toast.warning("Debe seleccionar un Empleado.");
            return;
        }
        if (!bean.Apply) {
            toast.warning("Debe seleccionar un Aplicar.");
            return;
        }
        if (!bean.IDEmploymentBonus) {
            toast.warning("Debe seleccionar un Beneficio.");
            return;
        }
        if (!bean.FromDate) {
            toast.warning("Debe seleccionar una Fecha desde.");
            return;
        }
        if (!bean.UptoDate) {
            toast.warning("Debe seleccionar una Fecha hasta.");
            return;
        }
        if (!bean.BonusValue) {
            toast.warning("Debe seleccionar un Valor Beneficio Empleado.");
            return;
        }
        instance.updateScheduleEmployeeBonus({ ...bean, IDEmployee: _single.getAccountID() }).then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDScheduleEmployeeBonus', visible: true },
        { title: 'Empleado', property: 'AccountName', visible: true },
        { title: 'Aplicar', property: 'Apply', visible: true },
        { title: 'Beneficio', property: 'BonusName', visible: true },
        { title: 'Fecha desde', property: 'FromDate', visible: true },
        { title: 'Fecha hasta', property: 'UptoDate', visible: true },
        { title: 'Valor Usuario', property: 'UserValue', visible: true },
        { title: 'Valor Beneficio Empleado', property: 'BonusValue', visible: true, mask: MASK_MONEY },
        { title: 'Tipo Beneficio', property: 'TypeName', visible: true },
        { title: 'Definir Salario Base de Liquidación', property: 'UseDefinedSalary', visible: true },
        { title: 'Salario Base de Liquidación', property: 'BaseSalary', visible: true, mask: MASK_MONEY },
        { title: 'Base de Liquidación', property: 'BaseValue', visible: true },
        { title: 'Beneficio Liquidado', property: 'BenefitValue', visible: true },
        { title: 'Unidades Liquidación', property: 'TimeUnits', visible: true },
        { title: 'Actualizado por', property: 'EmployeeName', visible: true },
        { title: 'Fecha Actualización', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open("Editar Beneficio temporal") } },
            { titulo: 'Consultar Liquidación de Beneficio', icono: 'ri-file-search-line', visible: _single.canEdit(), evento: () => { beneficiary.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open(); } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }



    return (
        <BasicPage titulo="Beneficiones Temporales">
            <div className="row">
                <div className="col-md-4">
                    <AccountEditor idAccount={Account} label="Empleado" onChange={(e) => { setAccount(e.IDAccount) }} />
                </div>
                <div className="col-md-4">
                    <EmployeeBonusEditor label="Beneficio" idSelector={EmployeeBonus} onChange={(e) => { setEmployeeBonus(e) }} />
                </div>
                <div className="col-md-4">
                    <InputDate label=" Fecha Corte" name="Dateform" value={fecha} setDate={(e: any) => { setfecha(e) }} ></InputDate>
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
                <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={editaItem}>
                    <div className="row">

                        <div className="col-md-6">
                            <AccountEditor idAccount={bean.IDAccount} label="Empleado" onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }} />
                        </div>
                        <div className="col-md-6">
                            <BasicSwitch label="Aplicar" estado={bean.Apply} eventChange={(e) => { setBean({ ...bean, "Apply": e }) }}></BasicSwitch>
                        </div>
                        <div className="col-md-6">
                            <EmployeeBonusEditor label="Beneficio" idSelector={bean.IDEmploymentBonus} onChange={(e) => { setBean({ ...bean, "IDEmploymentBonus": e }) }} />
                            {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                        </div>
                        <div className="col-md-6">
                            <InputDate label="Fecha desde" name="Dateform" value={bean.FromDate} setDate={(e) => { setBean({ ...bean, "FromDate": e }) }} ></InputDate>
                        </div>
                        <div className="col-md-6">
                            <InputDate label="Fecha hasta" name="Dateform" value={bean.UptoDate} setDate={(e) => { setBean({ ...bean, "UptoDate": e }) }} ></InputDate>
                        </div>
                        <div className="col-md-6">
                            <InputMoney _label="Valor Beneficio Empleado" _value={bean.BonusValue} onChange={(e) => { setBean({ ...bean, "BonusValue": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <BasicSwitch label="Definir Salario Base de Liquidación" estado={bean.UseDefinedSalary} eventChange={(e) => { setBean({ ...bean, "UseDefinedSalary": e }) }}></BasicSwitch>
                        </div>
                        <div className="col-md-6">
                            <InputMoney _label="Salario Base de Liquidación" _value={bean.BaseSalary} onChange={(e) => { setBean({ ...bean, "BaseSalary": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label >Base de Liquidación</label>
                            <input className="form-control" value={bean.BaseValue} readOnly />
                        </div>
                        <div className="col-md-6">
                            <label >Beneficio Liquidado</label>
                            <input className="form-control" value={bean.BenefitValue} readOnly />
                        </div>
                        <div className="col-md-6">
                            <label >Unidades Liquidación</label>
                            <input className="form-control" value={bean.TimeUnits} readOnly />
                        </div>

                    </div>
                </Modal>
                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.Name}</strong>
                </ModalConfirm>

                <Modal modal={beneficiary.modal} updateModal={beneficiary.setModal}  >
                    <ScheduleEmployeeBonusItem idScheduleEmployeeBonus={bean.IDScheduleEmployeeBonus} />
                </Modal>
            </div>
        </BasicPage>
    )
}